import { render, staticRenderFns } from "./AlertComponentBottom.vue?vue&type=template&id=3d888f99&scoped=true&"
import script from "./AlertComponentBottom.vue?vue&type=script&lang=ts&"
export * from "./AlertComponentBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d888f99",
  null
  
)

export default component.exports